
export const setFilters = (label: any, value: any | any) => {
  const filterRaw = localStorage.getItem('Filters');
  let filters = filterRaw ? JSON.parse(filterRaw) : ''
  if (filters) {
    filters = {...filters, [label]: value}
    localStorage.setItem('Filters', JSON.stringify(filters))
  } else {
    const individualFilter  = {
      [label]: value
    }
    localStorage.setItem('Filters', JSON.stringify(individualFilter))
  }
}

export const setSearch = (label: any, value: any) => {
  const searchRaw = localStorage.getItem('search');
  let search = searchRaw ? JSON.parse(searchRaw) : ''
  if (search) {
    search = {...search, [label]: value}
    localStorage.setItem('search', JSON.stringify(search))
  } else {
    const individualSearch  = {
      [label]: value
    }
    localStorage.setItem('search', JSON.stringify(individualSearch))
  }
}

export const getFilterValue = (label: any) => {
  const filterRaw = localStorage.getItem('Filters');
  const filters = filterRaw ? JSON.parse(filterRaw) : ''
  if (filters) {
    const individualFilter = filters?.[label]
    return individualFilter ?? ''
  } else return;
}

export const getSearchValue = (label: any) => {
  const searchRaw = localStorage.getItem('search');
  const search = searchRaw ? JSON.parse(searchRaw) : ''
  if (search) {
    const individualSearch = search?.[label]
    return individualSearch ?? ''
  } else return;
}

export const clearFilters = () => {
  const filters = localStorage.getItem('Filters');
  const search = localStorage.getItem('search');
  if (filters) {
    localStorage.removeItem('Filters')
  }
  if (search) {
    localStorage.removeItem('search')
  }
}